/* eslint-disable @typescript-eslint/no-explicit-any */
import { Socket } from "socket.io-client";
import { create } from "zustand";

export const useSocketIOStore = create<{
  isConnectionInitialised: boolean;
  startConnection: () => void;
  isSocketConnected: boolean;
  setSocketConnected: (connected: boolean) => void;
  socket?: Socket;
  socketId?: string;
  setSocket: (newSocket?: Socket) => void;
  setSocketId: (socketId?: string) => void;
  reset: () => void;
}>((set) => {
  return {
    isConnectionInitialised: false,
    isSocketConnected: false,
    startConnection: () => set(() => ({ isConnectionInitialised: true })),
    setSocketConnected: (connected: boolean) =>
      set(() => ({ isSocketConnected: connected })),
    socket: undefined,
    socketId: undefined,
    setSocket: (newSocket) =>
      set(() => ({ socket: newSocket, socketId: newSocket?.id })),
    setSocketId: (socketId) => set(() => ({ socketId })),
    reset: () =>
      set(() => ({
        isConnectionInitialised: false,
        isSocketConnected: false,
        socket: undefined,
        socketId: undefined,
      })),
  };
});
